import { theme } from 'antd';
import React from 'react';

interface BrandSiderHeaderProps {
  logoSrc?: string;
  logoAlt?: string;
  title?: string;
  collapsed?: boolean;
}

const BrandSiderHeader: React.FC<BrandSiderHeaderProps> = ({
  logoSrc,
  logoAlt,
  title = 'AI Nexus',
  collapsed = false,
}) => {
  const { token } = theme.useToken();
  const borderColor = `color-mix(in srgb, ${token.colorBorderSecondary} 86%, ${token.colorBgContainer})`;
  const fallbackMark = title.trim().charAt(0).toUpperCase() || 'A';

  if (collapsed) {
    return (
      <div style={{ padding: '12px 8px 8px', display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: token.borderRadiusLG,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: token.colorBgContainer,
            border: `1px solid ${borderColor}`,
          }}
        >
          {logoSrc ? (
            <img
              src={logoSrc}
              alt={logoAlt || title}
              style={{
                width: 24,
                height: 24,
                objectFit: 'contain',
                display: 'block',
              }}
            />
          ) : (
            <span
              style={{
                fontSize: 16,
                lineHeight: 1,
                fontWeight: 600,
                color: token.colorTextHeading,
              }}
            >
              {fallbackMark}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '12px 12px 8px' }}>
      <div
        style={{
          height: 40,
          display: 'flex',
          alignItems: 'center',
          padding: '0 4px',
        }}
      >
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={logoAlt || title}
            style={{
              display: 'block',
              width: '100%',
              maxWidth: 156,
              maxHeight: 28,
              objectFit: 'contain',
              objectPosition: 'left center',
            }}
          />
        ) : (
          <span
            style={{
              fontSize: 16,
              lineHeight: '24px',
              fontWeight: 600,
              color: token.colorTextHeading,
              letterSpacing: '-0.01em',
            }}
          >
            {title}
          </span>
        )}
      </div>
    </div>
  );
};

export default BrandSiderHeader;
